import React from "react";
import Layout from "../../layouts/default";
import ForgotPassword from "../../sections/ForgotPassword";

export default function Forgot() {
  return (
    <Layout>
      <ForgotPassword />
    </Layout>
  );
}
